import React from 'react';

import styled from 'styled-components';

import AddIcon from '../../../common/Icons/AddIcon';
import Button from '../../lib/Button';

const StyledButton = styled(Button)`
  display: flex;
  border: 1px solid var(--line-gray);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  font-size: 12px;
  line-height: 1;
  height: 30px;
  gap: 6px;
  align-items: center;

  &.borderless {
    border: none;
  }

  &.max-width {
    max-width: 150px;
  }
`;

interface Props {
  label: string;
  className?: string;
  style?: React.CSSProperties;
  onClick: () => void;
  dataTestId?: string;
}

const ShopDataModalAddButtonPill = ({ label, className, onClick, style, dataTestId }: Props) => {
  return (
    <StyledButton className={className} onClick={onClick} style={style} data-test-id={dataTestId}>
      <AddIcon size={16} />
      <span>{label}</span>
    </StyledButton>
  );
};

export default ShopDataModalAddButtonPill;
